<div class="worktable-container">
    <div class="worktable-header">
      <div class="header-left">
        <h2>Worktables</h2>
      </div>
      <div class="header-right">
        <button *ngIf="!isExpanded" class="view-all-btn" (click)="toggleExpand()">View All</button>
        <button *ngIf="isExpanded" class="close-btn" (click)="toggleExpand()"  matTooltip="Collapse All">
        </button>
      </div>
    </div>
    
    <div class="worktable-content">
      <div class="add-worktable">
        <button class="add-btn" (click)="addWorktable()">
        Add Worktable
        </button>
        <div class="counter">
          <span>{{ worktables?.length }}</span>
        </div>
      </div>
      
      <ng-container *ngIf="isExpanded">
        <div *ngFor="let worktable of worktables; trackBy: trackById" class="worktable-item">
          <div class="item-left">
            <span class="location-icon"></span>
            <span class="item-name">{{ worktable?.name }}</span>
          </div>
          <div class="item-right" [ngClass]="{ 'disabled': drawingMode }">
            <button class="delete-btn" (click)="deleteWorktable(worktable)" matTooltip="Delete Worktable"></button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>